import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import EchartComparison from '../dashboard/idealscomparison';
import * as axiosInstance from '../utils/axiosinstace';
import moment from "moment";import { useTranslation } from 'react-i18next';

const GrowthCurveComponent = (props) => {
  const { t } = useTranslation(['common', 'analytics', 'device', 'farm', 'batch', 'user']);
    const columns_male = [
        {
            name: t('common:time.day'),
            selector: "day",
            sortable: true,
           
        },
        {
            name: t('common:metrics.weight'),
            selector: "male",
            sortable: true,
            
        },
        {
            name: t('analytics:growth.idealWeight'),
            selector: "ideal_male",
            sortable: true,
        }
      ];
      const columns_female = [
        {
            name: t('common:time.day'),
            selector: "day",
            sortable: true,
           
        },
        {
            name: t('common:metrics.weight'),
            selector: "female",
            sortable: true,
            
        },
        {
            name: t('analytics:growth.idealWeight'),
            selector: "ideal_female",
            sortable: true,
        }
      ];
      const columns = [
        {
            name: t('common:time.day'),
            selector: "day",
            sortable: true,
           
        },
        {
            name: t('common:metrics.weight'),
            selector: "chickweight",
            sortable: true,
            
        },
        {
            name: t('analytics:growth.idealWeight'),
            selector: "ideal",
            sortable: true,
        }
      ];
    
    useEffect(() => {  
      
     },[]);
    return (
        
        <div className="growthCurve">
            {
                props.sexing =='yes'?
                <div>
                    <div className="row" style={{paddingTop: 20, paddingBottom: 20}}>
                        <div className="col-md-3">
                            <h3>{t('analytics:growth.birdGrowthMale')}</h3>
                        </div>
                        <div className="col-md-9">
                            <ul className="batchInfo">
                                <li><b>{t('analytics:growth.batchStatusColon')} </b><span className="textHiglighter"
                                style={{background: props.otherInfo.status=='ACTIVE'? '#218838': '#444'}}
                                >
                                    {props.otherInfo.status}
                                </span></li>
                                <li><b>{t('analytics:growth.startDateColon')} </b>{moment(props.otherInfo.startDate).format('DD-MMM-YYYY')}</li>
                                <li><b>{t('analytics:growth.endDateColon')} </b>{moment(props.otherInfo.endDate).format('DD-MMM-YYYY')}</li>
                                <li><b>{t('analytics:growth.durationColon')} </b>{props.otherInfo.batchDuration} Days</li>
                            </ul>
                        </div>
                    </div>
                     <div className="row">
                        
                        <div className="col-md-6">
                            <DataTable
                                columns={columns_male}
                                data={props.data}
                                defaultSortField="Day"
                                pagination
                                dense
                                selectableRowsHighlight = 'true'
                                compact
                                highlightOnHover = 'true'
                            />
                        </div>
                        <div className="col-md-6">
                            <EchartComparison key={Math.random()} xaxis={props.xaxis} legends = {props.maleLegends}  series={props.maleseries} max='4' ></EchartComparison>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <h3>{t('analytics:growth.birdGrowthFemaleLower')}</h3>
                        </div>
                        <div className="col-md-7">
                            <DataTable
                                columns={columns_female}
                                data={props.data}
                                defaultSortField="Day"
                                pagination
                                dense
                                selectableRowsHighlight = 'true'
                                compact
                                highlightOnHover = 'true'
                            />
                        </div>
                        <div className="col-md-5">
                            <EchartComparison key={Math.random()} xaxis={props.xaxis} legends = {props.femaleLegends}  series={props.femaleseries} max='4' ></EchartComparison>
                        </div>
                    </div>
                </div>
                :
                <div>
                     <div className="row" style={{paddingTop: 20, paddingBottom: 20}}>
                        <div className="col-md-3">
                            <h3>{t('analytics:growth.birdGrowth')}</h3>
                        </div>
                        <div className="col-md-9">
                            <ul className="batchInfo">
                                <li><b>{t('analytics:growth.batchStatusColon')} </b><span className="textHiglighter"
                                style={{background: props.otherInfo.status=='ACTIVE'? '#218838': '#444'}}
                                >
                                    {props.otherInfo.status}
                                </span></li>
                                <li><b>{t('analytics:growth.startDateColon')} </b>{moment(props.otherInfo.startDate).format('DD-MMM-YYYY')}</li>
                                <li><b>{t('analytics:growth.endDateColon')} </b>{moment(props.otherInfo.endDate).format('DD-MMM-YYYY')}</li>
                                <li><b>{t('analytics:growth.durationColon')} </b>{props.otherInfo.batchDuration} Days</li>
                            </ul>
                        </div>
                    </div>
                    <div className="row">
                      
                        <div className="col-md-6">
                        
                            <DataTable
                                columns={columns}
                                data={props.data}
                                defaultSortField="Day"
                                pagination
                                dense
                                selectableRowsHighlight = 'true'
                                compact
                                highlightOnHover = 'true'
                            />
                        </div>
                        <div className="col-md-6">
                            <EchartComparison key={Math.random()} xaxis={props.xaxis} legends = {props.chickLegends}  series={props.asHatchedSeries} max='5' ></EchartComparison>
                        </div>
                    </div>
                </div>
            }
           
        </div>
        
    );
}

export default GrowthCurveComponent;